import { useEffect, useLayoutEffect, useState } from "react";
import { connect, useStore } from "react-redux";
import { useHistory } from "react-router-dom";
import useMedia from "use-media";
import { useRtoaster } from "../../../hooks/useRtoaster";
import commonUtil from "../../../common/commonUtil";
import CommonValidation from "../../../common/commonValidation";
import { apiKeyCheck, changeReserve, getRightDigestionSelectionInfo, setReserve, versionGetApi } from "../../../const";
import messageConst from "../../../const/messageConst";
import common from "../../../resources/js/common/common";
import { Button } from "../../atoms/button";
import { Label } from "../../atoms/label";
import { PrivilegeIcon } from "../../atoms/privilegeIcon";
import { BreadCrumb } from "../../molecules/breadCrumb";
import { ErrorMassage } from "../../molecules/errorMassage";
import './../../../resources_membership_hotel/css/hotel/right.css';

const MembershipChooseRightContainer = (props) => {
    const {
        state,
        login,
        checkIn,
        checkOut,
        right,
        setRight,
        onClickOpenPopupWindow,
        setRightList,
        inputUserInfo,
        inputRoomList,
        membershipSearchParam,
        membershipReserveInfo,
        membershipReserveComf } = props;

    //レスポンシブ対応
    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });
    const [Phone, setPhone] = useState(false);
    const [Tablet, setTablet] = useState(false);
    const useMediaFlag = useMedia({ maxWidth: '480px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);

    const [linkList, setLinkList] = useState([]);

    const history = useHistory();
    const store = useStore();

    const loginType = login.loginType;
    const isCrawl = loginType === 'CRAWL';
    const crawlMember = store.getState().crawlMember;

    /** CRAWL用ユーザー情報設定 */
    const userInfo = isCrawl && crawlMember ?
        {
            syainNo: crawlMember.syain_no,
            uketukeCd: crawlMember.uketuke_cd,
            uketukeBashoCd: crawlMember.uketukebasyo_cd,
        } : null;

    // エラー情報
    const [errorInfo, setErrorInfo] = useState({ errorMessage: null, errorFlg: false, });

    // rtoasterタグ生成
    useRtoaster();

    useEffect(() => {
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
    }, [useMediaFlag]);

    useLayoutEffect(() => {
        // リフレッシュ対応
        let state = store.getState().login;
        let apiKey = null;
        if (Object.keys(state).length !== 0) {
            apiKey = state.apiKey;
        }
        if (apiKey === null) {
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
        if (apiKey) {
            common.doPost(apiKeyCheck, { apikey: apiKey }, afterApiKeyCheck);
        }
    })
    const afterApiKeyCheck = (res) => {
        if (!res.data) {
            console.log("バックからの戻り値false");
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
    }

    // API呼出等事前処理
    useEffect(() => {
        window.scroll({ top: 0, behavior: 'smooth' })
        if (loginType === "MEMBER") {
            setLinkList([
                { path: "/reserve/top", label: "HOME" },
                { path: "/reserve/hotel/search", label: "ホテル予約" },
                { path: "/reserve/hotel/searchResult", label: "検索結果" },
                { path: "/reserve/hotel/inputUser", label: "お客様情報入力", state: { locationInfo: history.location } }
            ]);
        } else if (loginType === "CRAWL") {
            setLinkList([
                { path: "/reserve/hotel/crawlSearch", label: "ホテル予約" },
                { path: "/reserve/hotel/searchResult", label: "検索結果" },
                { path: "/reserve/hotel/inputUser", label: "お客様情報入力", state: { locationInfo: history.location } }
            ]);
        }
        common.doPost(versionGetApi, {}, afterVerCheck);

        // 権利消化選択情報取得API
        common.doPost(getRightDigestionSelectionInfo, {
            keiyakuNo: membershipSearchParam.keiyakuNo,
            riyoKaiinkenSyubetCd: membershipSearchParam.riyoKaiinkenSyubetCd,
            shisetsuCd: membershipReserveInfo.shisetsuCd,
            riyoFirstdate: membershipSearchParam.checkInDate,
            hakuCnt: membershipSearchParam.nights,
        }, afterGetRightDigestionSelectionInfo);
        // setRightList([
        //     { date: "2023-04-01", nightsNum: -1, kbn: "gold", checked: false, index: 0 }, { date: "2023-04-02", nightsNum: -1, kbn: "gold", checked: false, index: 1 },
        //     { date: "2023-04-03", nightsNum: -1, kbn: "red", checked: false, index: 2 }, { date: "2023-04-04", nightsNum: -1, kbn: "red", checked: false, index: 3 },
        //     { date: "2023-04-05", nightsNum: -1, kbn: "white", checked: false, index: 4 }, { date: "2023-04-06", nightsNum: -1, kbn: "white", checked: false, index: 5 },
        //     { date: "2023-04-07", nightsNum: -1, kbn: "blue", checked: false, index: 6 }, { date: "2023-04-08", nightsNum: -1, kbn: "blue", checked: false, index: 7 }
        // ]);
        // setRight([
        //     { senyuDate: "2022-01-01", senyuKenriIro: "gold", siyoDate: [{ shokaKenriIro: "", shokaKenriDate: "" }, { shokaKenriIro: "", shokaKenriDate: "" }] },
        //     { senyuDate: "2022-02-02", senyuKenriIro: "white", siyoDate: [{ shokaKenriIro: "", shokaKenriDate: "" }, { shokaKenriIro: "", shokaKenriDate: "" }] },
        // ]);
    }, []);

    // 権利消化選択情報取得後処理
    const afterGetRightDigestionSelectionInfo = (res) => {
        const data = res.data;
        if (data.resultCode == 0) {
            let stayList = [];
            let setRightFlg = true;
            if (membershipReserveInfo.changeFlg && membershipReserveComf.shokaKenriList) { // 予約変更かつ変更前予約に権利消化あり
                membershipReserveComf.shokaKenriList.forEach(value => {
                    let shokaList = [];
                    value.shokaList.forEach(item => {
                        shokaList.push({ shokaKenriIro: item.shokaKenriIro, shokaKenriDate: item.shokaDate });
                    })
                    stayList.push({
                        senyuDate: shokaList,
                        senyuKenriIro: value.shokaKenriIro,
                        siyoDate: value.riyoDate
                    });
                })
            } else { // 新規予約または更前予約に権利消化なし
                //新規遷移時
                if(right === undefined || right.length === 0){
                    if (membershipReserveInfo.machiFlg == "2") {
                        data.stayInfoList.forEach((value, index)=> {
                            let shokaList = [];
                            const targetCnt = inputRoomList?.filter(room => room.roomDayList?.find(date => date.day == value.stayDate)?.zanRoom > 0)?.length;
                            for (let i = 0; i < targetCnt; i++) {
                                shokaList.push({ shokaKenriIro: "", shokaKenriDate: "" });
                            }
                            if (shokaList.length) {
                                stayList.push({
                                    senyuDatHyojiOkFlg: value.senyuDatHyojiOkFlg,
                                    senyuDatHyojiDaitaiStr: value.senyuDatHyojiDaitaiStr,
                                    senyuDate: shokaList,
                                    senyuKenriIro: value.stayKenriIroKbn,
                                    siyoDate: value.stayDate,
                                    stayNum: index + 1
                                });
                            }
                        })
                    } else {
                        let shokaList = [];
                        for (let i = 0; i < membershipSearchParam.roomCnt; i++) {
                            shokaList.push({ shokaKenriIro: "", shokaKenriDate: "" });
                        }
                        data.stayInfoList.forEach((value, index) => {
                            stayList.push({
                                senyuDatHyojiOkFlg: value.senyuDatHyojiOkFlg,
                                senyuDatHyojiDaitaiStr: value.senyuDatHyojiDaitaiStr,
                                senyuDate: shokaList,
                                senyuKenriIro: value.stayKenriIroKbn,
                                siyoDate: value.stayDate,
                                stayNum: index + 1
                            });
                        })
                    }
                }else{ //rightリダックスに値が残っていればそれを使う
                    setRightFlg = false;
                }
            }
            if(setRightFlg) setRight(stayList);
            let kenriList = [];
            let senyuDatHyojiDaitaiStr = "";
            if(!data.senyuDatHyojiOkFlg) {
                senyuDatHyojiDaitaiStr = data.senyuDatHyojiDaitaiStr;
            }
            //消化権利データの成形
            let idx = 0;
            data.shokaKenriDayList.map((dayValue) => {
                dayValue.shokaKenriList.forEach((value, index) => {
                    let contFlg = false;
                    let dateList = [];
                    if(kenriList.length !== 0){
                        kenriList.map((kenri) => {
                            //すでに同一権利消化データが存在する場合は利用日に利用できる日付を追加する
                            if(value.shokaKenriDate === kenri.date
                                && value.shokaKenriIroKbn === kenri.kbn
                                && dayValue.riyoDate !== kenri.riyoDate){
                                    kenri.riyoDate.push(dayValue.riyoDate);
                                    contFlg = true;
                            }
                        })
                        if(contFlg) return;
                    }
                    dateList.push(dayValue.riyoDate);
                    if(data.senyuDatHyojiOkFlg) {
                        kenriList.push({ 
                            date: value.shokaKenriDate,
                            nightsNum: -1,
                            kbn: value.shokaKenriIroKbn,
                            checked: false,
                            index: idx,
                            senyuDatHyojiOkFlg: value.senyuDatHyojiOkFlg,
                            senyuDatHyojiDaitaiStr: value.senyuDatHyojiDaitaiStr,
                            riyoDate: dateList,
                        });
                    } else {
                        kenriList.push({ 
                            date: value.shokaKenriDate,
                            nightsNum: -1,
                            kbn: value.shokaKenriIroKbn,
                            checked: false,
                            index: idx,
                            senyuDatHyojiOkFlg: data.senyuDatHyojiOkFlg,
                            senyuDatHyojiDaitaiStr: senyuDatHyojiDaitaiStr,
                            riyoDate: dateList,
                        });
                    }
                    idx++;
                })
            })
            setRightList(kenriList);
        }
    }

    const afterVerCheck = (res) => {
        let flg = common.versionCheck(res.data.version);
        if (flg) {
            history.push("/reserve/login");
            return;
        }
    }

    // 「変更」ボタン押下時処理
    const onClickChange = (nightsNum, rightObj) => {
        let sumDateStr = dateConvert(nightsNum);
        right.forEach((value, index) => {
            let newList = [];
            state.rightList.forEach(item => {
                //利用できる日付か否かをチェック
                let dateFlg = false;
                item.riyoDate.map((date) => {
                    if(date === sumDateStr){
                        dateFlg = true;
                    }
                })
                item.riyoDateFlg = dateFlg;
                if (value.senyuDate.some(kenri => kenri.shokaKenriDate === item.date && dateFlg)) {
                    item.checked = true;
                    item.nightsNum = index;
                }
                newList.push(item);
                setRightList(newList);
            })
        })
        onClickOpenPopupWindow(nightsNum, rightObj);
    }

    // 日付をidx分進めてyyyy-mm-ddで返却
    const dateConvert = (idx) => {
        let date = new Date(membershipSearchParam.checkInDate);
        date.setDate(date.getDate() + idx);
        var y = date.getFullYear();
        var m = ('00' + (date.getMonth()+1)).slice(-2);
        var d = ('00' + date.getDate()).slice(-2);
        return (y + '-' + m + '-' + d);
    }

    // 「戻る」ボタン押下時処理
    const onClickBack = () => {
        history.push("/reserve/hotel/inputUser", { locationInfo: history.location });
    }

    // 予約登録チェック後処理
    const afterSetReserve = (res) => {
        let data = res.data;
        if (data.resultCode == 0) {
            history.push("/reserve/hotel/confirmUser");
        } else {
            setErrorInfo({ errorMessage: [data.errorMessage], errorFlg: true })
        }
    }

    // 「確認画面へ」ボタン押下時処理
    const onClickCheckInput = () => {
        let errFlg = false;
        right.forEach(value => {
            value.senyuDate.forEach(item => {
                if (CommonValidation.Require(item.shokaKenriIro)) {
                    errFlg = true;
                }
            })
        })
        if (errFlg) {
            setErrorInfo({ errorMessage: [messageConst.SELECT_RIGHT_ERROR], errorFlg: true, });
        } else {
            setErrorInfo({ errorMessage: null, errorFlg: false, });
            let reqShokaKenriList = [];
            right.forEach(senyu => {
                let reqSenyuDate = [];
                senyu.senyuDate.forEach(shoka => {
                    reqSenyuDate.push(shoka.shokaKenriDate);
                })
                reqShokaKenriList.push({ senyuDate: reqSenyuDate, siyoDate: senyu.siyoDate });
            })
            let req = {};
            if (membershipReserveInfo.changeFlg) {
                // リクエスト設定
                req = {
                    shisetsuCd: membershipReserveInfo.shisetsuCd,
                    yoyakuNo: membershipReserveInfo.yoyakuNo,
                    keiyakuNo: membershipSearchParam.keiyakuNo,
                    riyoKaiinkenSyubetCd: membershipSearchParam.riyoKaiinkenSyubetCd,
                    pointKaiinId: membershipSearchParam.memberCd,
                    riyoDate: membershipSearchParam.checkInDate,
                    hakuCnt: membershipSearchParam.nights,
                    planCd: membershipReserveInfo.planCd,
                    planShohinCd: membershipReserveInfo.planShohinCd,
                    foodRequest: inputUserInfo.foodRequest,
                    allergyKbn: inputUserInfo.allergyKbn,
                    allergyBiko: inputUserInfo.allergyBiko,
                    daihyouNameKana: inputUserInfo.daihyouNameKana,
                    daihyouName: inputUserInfo.daihyouName,
                    mainPhoneKbn: inputUserInfo.mainPhoneKbn,
                    mainPhoneNumber: inputUserInfo.mainPhoneNumber,
                    contactPhoneNumber: inputUserInfo.contactPhoneNumber,
                    contactMailAddress: inputUserInfo.contactMailAddress,
                    relationCd: inputUserInfo.relationCd,
                    prefectureCd: inputUserInfo.prefectureCd,
                    transportCd: inputUserInfo.transportCd,
                    carCnt: inputUserInfo.carCnt,
                    busTime: inputUserInfo.busTime,
                    kozafurikaeFlg: inputUserInfo.kozafurikaeFlg,
                    smartCheckInFlg: inputUserInfo.smartCheckInFlg,
                    smartCheckOutFlg: inputUserInfo.smartCheckOutFlg,
                    nonstopCheckInFlg: inputUserInfo.nonstopCheckInFlg,
                    biko: inputUserInfo.biko,
                    kakuninMailKiboKbn: inputUserInfo.kakuninMailKiboKbn ? "1" : "0",
                    kakuninMailAddress: inputUserInfo.confirmReserveMail,
                    machiFlg: inputUserInfo.machiFlg,
                    roomList: inputUserInfo.roomList,
                    foodList: inputUserInfo.foodList,
                    foodCourseList: inputUserInfo.foodCourseList,
                    shokaKenriList: reqShokaKenriList,
                    dinnerTsukiFlg: membershipReserveInfo.dinnerTsukiPlanFlg,
                    breakfastTsukiFlg: membershipReserveInfo.breakfastTsukiPlanFlg,
                    registFlg: false,
                    userInfo,
                }

                common.doPost(changeReserve, req, afterSetReserve);
            } else {
                // リクエスト設定
                req = {
                    shisetsuCd: membershipReserveInfo.shisetsuCd,
                    keiyakuNo: membershipSearchParam.keiyakuNo,
                    riyoKaiinkenSyubetCd: membershipSearchParam.riyoKaiinkenSyubetCd,
                    pointKaiinId: membershipSearchParam.memberCd,
                    riyoDate: membershipSearchParam.checkInDate,
                    hakuCnt: membershipSearchParam.nights,
                    planCd: membershipReserveInfo.planCd,
                    planShohinCd: membershipReserveInfo.planShohinCd,
                    foodRequest: inputUserInfo.foodRequest,
                    allergyKbn: inputUserInfo.allergyKbn,
                    allergyBiko: inputUserInfo.allergyBiko,
                    daihyouNameKana: inputUserInfo.daihyouNameKana,
                    daihyouName: inputUserInfo.daihyouName,
                    mainPhoneKbn: inputUserInfo.mainPhoneKbn,
                    mainPhoneNumber: inputUserInfo.mainPhoneNumber,
                    contactPhoneNumber: inputUserInfo.contactPhoneNumber,
                    contactMailAddress: inputUserInfo.contactMailAddress,
                    relationCd: inputUserInfo.relationCd,
                    prefectureCd: inputUserInfo.prefectureCd,
                    transportCd: inputUserInfo.transportCd,
                    carCnt: inputUserInfo.carCnt,
                    busTime: inputUserInfo.busTime,
                    kozafurikaeFlg: inputUserInfo.kozafurikaeFlg,
                    smartCheckInFlg: inputUserInfo.smartCheckInFlg,
                    smartCheckOutFlg: inputUserInfo.smartCheckOutFlg,
                    nonstopCheckInFlg: inputUserInfo.nonstopCheckInFlg,
                    biko: inputUserInfo.biko,
                    kakuninMailKiboKbn: inputUserInfo.kakuninMailKiboKbn ? "1" : "0",
                    kakuninMailAddress: inputUserInfo.confirmReserveMail,
                    machiFlg: inputUserInfo.machiFlg,
                    roomList: inputUserInfo.roomList,
                    foodList: inputUserInfo.foodList,
                    foodCourseList: inputUserInfo.foodCourseList,
                    shokaKenriList: reqShokaKenriList,
                    importedFlg: membershipReserveInfo.generalFlg,
                    dinnerTsukiFlg: membershipReserveInfo.dinnerTsukiPlanFlg,
                    breakfastTsukiFlg: membershipReserveInfo.breakfastTsukiPlanFlg,
                    registFlg: false,
                    userInfo,
                }

                common.doPost(setReserve, req, afterSetReserve);
            }
        }
    }

    return (
        <div>
            <BreadCrumb
                breadCrumbStyle={isWideTablet ? { display: "none" } : style.breadCrumb}
                linkStyle={style.link}
                linkList={linkList}
                lastLabel="使用する権利消化を選択"
                lastLabelClassName="lastLabel"
            />
            <div className={isMobilePhone ? "rightWrapMobile" : "rightWrap"}>
                <Label
                    label={ membershipReserveInfo.machiFlg === "2" ? "本予約は一部キャンセル待ちとなります。以下に表示されている日程はお部屋に空室がございますので消化する権利をご選択ください。" : ''}
                    className={ membershipReserveInfo.machiFlg === "2" ? "cancelMachiPlanCheckLabel" : ""}
                />
                {right.map((value, index) =>
                    <div key={"right" + index}>
                        <div className={isMobilePhone ? "nightsNumMobile" : "nightsNum"}>
                            <Label label={value.stayNum + "泊目"} className="nightsNumText" />
                        </div>
                        <div className={isMobilePhone ? "rightInnerWrapMobile" : "rightInnerWrap"}>
                            <div className="rightDispAreaBorder">
                                <Label label="宿泊日" className="stayDateText" />
                                <div className="rightItem">
                                    <div className="rightImage">
                                        <PrivilegeIcon className={value.senyuKenriIro} />
                                    </div>
                                    <Label label={commonUtil.getStringFromDateJpnMembership(value.siyoDate)} className="" />
                                </div>
                            </div>
                            <div className={setRight.length === (index + 1) ? "rightDispAreaBorder" : "rightDispArea"}>
                                <Label label="消化権利" className="stayDateText" />
                                <div className="selectRightArea">
                                    <div>
                                        {
                                        // value.senyuDatHyojiOkFlg ?
                                            value.senyuDate.some(item => item.shokaKenriDate === "") ?
                                                <div className="rightItem" key="rightItemUnSelected">
                                                    <Label label="権利消化を選択してください。" className="" />
                                                </div>
                                                :
                                                value.senyuDate.map((item, itemIndex) =>
                                                    item.senyuDatHyojiOkFlg ?
                                                    <div className="rightItem" key={"rightItem" + itemIndex}>
                                                        <div className="rightImage">
                                                            <PrivilegeIcon className={item.shokaKenriIro} />
                                                        </div>
                                                        <Label label={commonUtil.getStringFromDateJpnMembership(item.shokaKenriDate)} className="" />
                                                    </div>
                                                    :
                                                    <div className="rightItem" key={"rightItem" + itemIndex}>
                                                        <div className="rightImage">
                                                            <PrivilegeIcon className={item.shokaKenriIro} />
                                                        </div>
                                                        <Label label={item.senyuDatHyojiDaitaiStr} className="" />
                                                    </div>
                                                )
                                            // :
                                            // <div className="rightItem" key="rightItemUnSelected">
                                            //     <Label label={value.senyuDatHyojiDaitaiStr} className="" />
                                            // </div>
                                        }
                                    </div>
                                    <Button buttonText="変更" className={isMobilePhone ? "rightBtnChangeMobile" : "rightBtnChange"} onClick={() => onClickChange(index, value)} />

                                </div>
                            </div>
                        </div>
                    </div>
                )}
                <div style={errorInfo.errorFlg ? style.errorDiv : { display: "none" }}>
                    <ErrorMassage style={style.errorMassage} data={errorInfo.errorMessage} />
                </div>
                <div className={isMobilePhone ? "rightBtnWrapMobile" : "rightBtnWrap"}>
                    <div class="rightBtnArea">
                        <Button buttonText="戻る" className="rightBtnBack" onClick={onClickBack} />
                        <Button buttonText="確認画面へ" className="rightBtnToConfirm" onClick={onClickCheckInput} />
                    </div>
                </div>
            </div>
        </div>
    );

};

const style = {
    breadCrumb: {
        display: "flex",
        color: "white",
        margin: "8px auto 20px auto",
        width: "60%",
    },
    breadCrumbArrow: {
        marginRight: "16px",
        marginTop: "0px",
    },
    link: {
        display: "inline-block",
        padding: "3px",
        color: "white",
        fontSize: "small",
    },
    errorMassage: {
        display: "inline-block",
        textAlign: "left",
    },
    errorDiv: {
        display: "block",
        color: "red",
        textAlign: "center",
        fontSize: "0.8rem",
        background: "rgba(255,255,255,0)",
        border: 0,
        fontWeight: "bold",
        margin: "0px 0px 10px 0px",
    },
};

const mapStateToProps = (state) => {
    return {
        login: state.login,
        checkIn: state.checkIn,
        checkOut: state.checkOut,
        right: state.right,
        inputUserInfo: state.inputUserInfo,
        inputRoomList: state.inputRoomList,
        membershipSearchParam: state.membershipSearchParam,
        membershipReserveInfo: state.membershipReserveInfo,
        membershipReserveComf: state.membershipReserveComf
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setRight: (item) => {
            dispatch({ type: "RIGHT", payload: { right: item } })
        },
    };
}

export default connect(mapStateToProps, mapToDispatchToProps)(MembershipChooseRightContainer);
